export const setSealCertificate = (state, payload) => state.seal_certificate = payload;
